var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
const SvgGroup1227 = _ref => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 50 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.1 0H11.453C5.128 0 0 4.668 0 10.427v24.26c0 5.76 5.128 10.428 11.453 10.428H38.1c6.325 0 11.453-4.669 11.453-10.427V10.427C49.553 4.668 44.425 0 38.1 0Z",
    fill: "#04B469"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.029 21.166c1.187 0 2.15-1.478 2.15-3.3 0-1.822-.963-3.299-2.15-3.299-1.187 0-2.15 1.477-2.15 3.3 0 1.821.963 3.299 2.15 3.299ZM35.526 21.166c1.188 0 2.15-1.478 2.15-3.3 0-1.822-.962-3.299-2.15-3.299-1.187 0-2.149 1.477-2.149 3.3 0 1.821.962 3.299 2.15 3.299ZM32.157 25.35c.446 0 .885.104 1.275.302.39.198.717.483.951.83.235.345.368.74.388 1.145.02.406-.074.81-.274 1.173-1.632 2.991-5.325 5.077-9.618 5.077s-7.986-2.086-9.621-5.077a2.208 2.208 0 0 1-.272-1.172c.02-.406.154-.8.388-1.145.234-.346.561-.631.95-.83.39-.198.828-.302 1.274-.303h14.559Z",
    fill: "#3B3735"
  })));
};
export { SvgGroup1227 as ReactComponent };
export default __webpack_public_path__ + "8f91bf359fe9e1af8ca04d9dfb85bea3.svg";